module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (18).3e1fb329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (18).jpg
// module id = 340
// module chunks = 0